import { fetchApi } from "./utils";

export const fetchCheckoutSession = async (pricing, email, coupon) =>
  fetchApi(`/stripe/get-sessionID`, {
    method: "POST",
    params: { pricing, email, coupon },
  });

export const fetchCustomerPortalSession = async (customerID) =>
  fetchApi(`/stripe/fetch-customer-portal`, {
    method: "POST",
    params: { customerID },
  });

export const checkCouponValidity = async (coupon) =>
  fetchApi(`/stripe/check-coupon`, {
    method: "POST",
    params: { coupon },
  });
